import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PianoIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 29613573">
        <path id="Vector" d="M23.9997 22.4009H20.7998V24.001H23.9997V22.4009Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_2" d="M19.1999 22.4009H12.7998V24.001H19.1999V22.4009Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_3" d="M11.1999 22.4009H4.7998V24.001H11.1999V22.4009Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_4" d="M3.19987 22.4009H0V24.001H3.19987V22.4009Z" fill={fillColor || '#F6F6F7'} />
        <path
          id="Vector_5"
          d="M17.5999 3.19971H14.4001V11.1999H11.2002V12.7996H14.4001V14.3997H12.7999V20.7998H19.2001V14.3997H17.5999V3.19971Z"
          fill={fillColor || '#F6F6F7'}
        />
        <path
          id="Vector_6"
          d="M9.60032 3.19971H6.40045V11.1999H3.2002V12.7996H6.40045V14.3997H4.80032V20.7998H11.2004V14.3997H9.60032V3.19971Z"
          fill={fillColor || '#F6F6F7'}
        />
        <path id="Vector_7" d="M1.60013 3.19971H0V20.7998H3.19987V14.3997H1.60013V3.19971Z" fill={fillColor || '#F6F6F7'} />
        <path
          id="Vector_8"
          d="M22.4001 11.1999H19.2002V12.7996H22.4001V14.3997H20.8003V20.7998H24.0002V3.19971H22.4001V11.1999Z"
          fill={fillColor || '#F6F6F7'}
        />
        <path id="Vector_9" d="M24 0.000488281H0V1.6006H24V0.000488281Z" fill={fillColor || '#F6F6F7'} />
      </g>
    </svg>
  );
};

export { PianoIcon };
